import { useContext } from 'react'
import {
  PlayFill,
  PauseFill,
  SkipEndFill,
  SkipStartFill,
  Repeat,
  Shuffle,
} from 'react-bootstrap-icons'
import { PlayerContext } from '../../pages/Home'

const PlayControls = () => {
  const {
    isPlaying,
    setIsPlaying,
    repeat,
    setRepeat,
    shuffle,
    setShuffle,
    previousRecording,
    nextRecording,
  } = useContext(PlayerContext)

  return (
    <>
      <button
        className='btn border-0 p-2 ps-3 pe-3'
        onClick={() => setRepeat(!repeat)}
      >
        <Repeat
          className={'w-100 control ' + (repeat ? 'active' : 'inactive')}
          size={22}
        />
      </button>
      <button
        className='btn border-0 m-1 p-2 ps-3 pe-3'
        onClick={() => previousRecording()}
      >
        <SkipStartFill className='w-100 text-light-emphasis' size={24} />
      </button>
      <button
        className='btn border-0 m-1 p-2 ps-3 pe-3'
        onClick={() => setIsPlaying(!isPlaying)}
      >
        {isPlaying ? (
          <PauseFill className='w-100 text-light-emphasis' size={48} />
        ) : (
          <PlayFill className='w-100 text-light-emphasis' size={48} />
        )}
      </button>
      <button
        className='btn border-0 m-1 p-2 ps-3 pe-3'
        onClick={() => nextRecording()}
      >
        <SkipEndFill className='w-100 text-light-emphasis' size={24} />
      </button>
      <button
        className='btn border-0 p-2 ps-3 pe-3'
        onClick={() => setShuffle(!shuffle)}
      >
        <Shuffle
          className={'w-100 control ' + (shuffle ? 'active' : 'inactive')}
          size={22}
        />
      </button>
    </>
  )
}
export default PlayControls
